import { motion } from "framer-motion";
import {
  Wallet, MapPin, TrendingUp, PieChart, Smile,
  Target, PackageX, Clock, ShieldCheck,
} from "lucide-react";

const QUESTIONS = [
  { Icon: Wallet, q: "Where is our money going?" },
  { Icon: MapPin, q: "Which branch is performing best?" },
  { Icon: TrendingUp, q: "Are sales increasing?" },
  { Icon: PieChart, q: "Which products make the most profit?" },
  { Icon: Smile, q: "Are our customers satisfied?" },
  { Icon: Target, q: "Are staff meeting their targets?" },
  { Icon: PackageX, q: "Is inventory running low?" },
  { Icon: Clock, q: "Are projects on schedule?" },
  { Icon: ShieldCheck, q: "Are we meeting regulatory requirements?" },
];

export default function OpsQuestions() {
  return (
    <section data-testid="section-questions" className="relative bg-[#142645] text-[#F1ECE0] border-t border-white/5 overflow-hidden">
      <div className="absolute inset-0 ops-grid-bg opacity-40 pointer-events-none" />
      <div className="relative max-w-[1400px] mx-auto px-6 md:px-12 py-20 md:py-28">
        <div className="max-w-3xl mb-14 md:mb-16">
          <div className="text-[11px] uppercase tracking-[0.25em] font-semibold text-[#D9FF3C] mb-6 inline-flex items-center gap-2">
            <span className="inline-block h-1.5 w-1.5 rounded-full bg-[#D9FF3C]" />
            The questions leaders ask
          </div>
          <h2 className="font-editorial text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
            Is your business asking
            <br />
            <span className="italic">these questions?</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {QUESTIONS.map(({ Icon, q }, i) => (
            <motion.div
              key={q}
              data-testid={`question-${i + 1}`}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
              whileHover={{ y: -4 }}
              className="group relative border border-white/10 p-6 md:p-7 bg-[#1A2E4A]/60 hover:border-[#D9FF3C] hover:bg-[#1A2E4A] transition-colors"
            >
              <div className="flex items-start justify-between mb-6">
                <div className="h-14 w-14 rounded-full bg-[#D9FF3C]/10 flex items-center justify-center group-hover:bg-[#D9FF3C] transition-colors">
                  <Icon size={26} strokeWidth={1.4} className="text-[#D9FF3C] group-hover:text-[#142645] transition-colors" />
                </div>
                <span className="text-[10px] font-plex-mono uppercase tracking-[0.22em] text-[#F1ECE0]/30">
                  Q{String(i + 1).padStart(2, "0")}
                </span>
              </div>
              <p className="font-editorial text-2xl md:text-[26px] leading-tight tracking-tight text-[#F1ECE0]">
                {q}
              </p>
            </motion.div>
          ))}
        </div>

        <div className="mt-14 md:mt-16 flex flex-col md:flex-row md:items-center justify-between gap-6 border-t border-white/10 pt-10">
          <p className="font-editorial text-2xl md:text-3xl leading-tight tracking-tight text-[#F1ECE0] max-w-3xl">
            OpsIQ helps you answer these questions
            <span className="italic text-[#D9FF3C]"> in one place.</span>
          </p>
        </div>
      </div>
    </section>
  );
}
